<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <label class="title">中心详情</label>
          </a-col>

          <!--<a-col :md="6" :sm="8">-->
          <!--<span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">-->
          <!--<a-button type="primary" @click="searchQuery" icon="search">查询</a-button>-->
          <!--<a-button type="" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
          <!--<a @click="handleToggleSearch" style="margin-left: 8px">-->
          <!--{{ toggleSearchStatus ? '收起' : '展开' }}-->
          <!--<a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
          <!--</a>-->
          <!--</span>-->
          <!--</a-col>-->

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <a-row style="margin-top: 5px;margin-bottom: 5px">
      <a-col :span="12">
        <label style="margin-right: 20px">研究中心：{{centerName}}</label>
        <a-date-picker @change="searchQuery" style="margin-left: 10px;margin-right: 10px" value-format='YYYY-MM-DD' v-model="queryParam.currentDate" />
        <a-button @click="viewCenter" type="primary" icon="plus">查看全部中心</a-button>
      </a-col>
      <a-col :span="12" style="text-align: right">
        <standard-filter @loadData="loadData"></standard-filter>
      </a-col>

    </a-row>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"

        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">
        <span slot="endIsStandard" style="color: green">
          达标完成人数（占比）
        </span>
        <span slot="endNoStandard" style="color: red">未达标完成人数（占比）</span>
      </a-table>
    </div>

  </a-card>
</template>

<script>
  import moment from 'moment';
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'

  import Vue from 'vue'
  import StandardFilter from './StandardFilter'
  export default {
    name: "Info",
    mixins: [JeecgListMixin],
    components: {
      StandardFilter

    },
    props:['centerId'],
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        centerName:'',
        columns: [
          {
            title: '周期',
            align: "center",
            dataIndex: 'name',
            width: 120,
          },
          {
            title: '应随访总人数',
            align: "center",
            dataIndex: 'total',
            width: 120,
          },
          {
            title: '完成随访',
            align: "center",
            children:[
              {
                title: '总人数（占比）',
                align: "center",
                width: 120,
                dataIndex: 'submitCount',
                customRender:(value,row,index)=>{
                  return this.rowCustomRender(value,row,'submitCountRate')
                }
              },
              {
                // title: '达标完成人数（占比）',
                align: "center",
                width: 120,
                dataIndex: 'endIsStandard',
                slots: { title: 'endIsStandard' },
                customRender:(value,row,index)=>{
                  return this.rowCustomRender(value,row,'endIsStandardRate')
                }
              },
              {
                // title: '未达标完成人数（占比）',
                align: "center",
                width: 120,
                dataIndex: 'endNoStandard',
                slots: { title: 'endNoStandard' },
                customRender:(value,row,index)=>{
                  return this.rowCustomRender(value,row,'endNoStandardRate')
                }
              },
            ],
          },
          {
            title: '进行中随访',
            align: "center",
            children:[
              {
                title: '总人数（占比）',
                align: "center",
                width: 120,
                dataIndex: 'inCount',
                customRender:(value,row,index)=>{
                  return this.rowCustomRender(value,row,'inCountRate')
                }
              },
            ],
          },
          {
            title: '未开始随访',
            align: "center",
            children:[
              {
                title: '总人数（占比）',
                align: "center",
                width: 120,
                dataIndex: 'noCount',
                customRender:(value,row,index)=>{
                  return this.rowCustomRender(value,row,'noCountRate')
                }
              },
            ],
          },
          {
            title: '操作',
            align: "center",
            dataIndex: 'action',
            width: 120,
            customRender: (value, row, index) => {
              const child = this.$createElement('a', {
                domProps: {
                  innerHTML: '详情'
                },
                on: {
                  click: ()=> {
                    this.viewItem(row)
                  }
                }
              })
              return {
                children: child,
                attrs: {},
              };
            },
          },
        ],
        url: {
          list: "/project/statistic/visitRate/info",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      if(this.centerId){
        this.$set(this.queryParam,'currentDate',moment().format('YYYY-MM-DD'))
        this.queryParam.centerId = this.centerId
        this.queryParam.projectId = this.projectId
        this.loadCenterName()
        this.loadData()
      }
    },
    watch:{
      centerId(){
        if(this.centerId){
          this.queryParam.centerId = this.centerId
          this.queryParam.projectId = this.projectId
          this.$set(this.queryParam,'currentDate',moment().format('YYYY-MM-DD'))
          this.loadCenterName()
          this.loadData()
        }

      }
    },
    methods: {
      moment,
      viewItem(row){
        // 查看基线的表单
        this.$emit('change',row.id)
      },
      viewCenter(){
        this.$emit('typeChange','2')
      },

      loadCenterName(){
        if(this.centerId){
          getAction('/management/center/queryById',{id:this.centerId}).then(res=>{
            if(res.success){
              this.centerName = res.result.name
            }
          })
        }
      },
      rowCustomRender(value,row,rateKey){
        return `${value}(${row[rateKey]}%)`
      }
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>
